exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".splash-container {\n  height: 100%; }\n\n.welcome-content {\n  color: #fff;\n  font-size: 18px;\n  padding-bottom: 30px;\n  min-height: 100%; }\n  .welcome-content h1 {\n    font-weight: bold;\n    letter-spacing: -3px;\n    line-height: 1; }\n  .welcome-content p {\n    line-height: 1.4; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/dev/um.stamps/src/app/splash/splash.component.scss
// module id = ../../../../../src/app/splash/splash.component.scss
// module chunks = main